module.exports = __webpack_public_path__ + "img/prolungato_bilaterale_dx.4f790205.png";